import { render } from "./post-smtp-dashboard.vue?vue&type=template&id=b8fab578&scoped=true"
import script from "./post-smtp-dashboard.vue?vue&type=script&lang=js"
export * from "./post-smtp-dashboard.vue?vue&type=script&lang=js"

import "./post-smtp-dashboard.vue?vue&type=style&index=0&id=b8fab578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8fab578"]])

export default __exports__